export default "__VITE_ASSET__BdAxNxlx__"